import React from 'react';

import dayjs from "dayjs";

import {CardOverflow, Stack} from "@mui/joy";
import Card from "@mui/joy/Card";
import CardContent from "@mui/joy/CardContent";
import Grid from "@mui/joy/Grid";
import DeliveryTable from "../Delivery/DeliveryTable";
import Chip from "@mui/joy/Chip";
import Typography from "@mui/joy/Typography";
import Link from "@mui/joy/Link";

// components
import withNavigate from "../../utils/withNavigate";
import CommonInfoTab from "../Common/CommonInfoTab";
import OpportunityPaymentCert from "../Opportunity/OpportunityPaymentCert";
import CommentItem from "../Comment/CommentItem";
import UserSubscriberContext from "../../context/UserSubscriberContext";


class OpportunityFullCard extends React.Component {
    static contextType = UserSubscriberContext

    constructor(props) {
        super(props);
        this.state = {
            comments: this.props.comments,
        };
    }

    addComment(comment) {
        if (comment) {
            this.setState((state) => ({
                    comments: [
                        comment,
                        ...state.comments,
                    ],
                })
            );
        }
    }

    render() {
        return (
            <Card
                orientation="horizontal"
                variant="outlined"
                sx={{
                    width: this.props.width?this.props.width:null
                }}
            >
                {
                    this.props.showStatus ?
                        <CardOverflow
                            variant='soft'
                            color={
                                (() => {
                                    switch (this.props.opportunity.status) {
                                        case 'OPENX':
                                            return 'primary'
                                        case 'CLOSE':
                                            return 'success'
                                        case 'LOSTX':
                                            return 'danger'
                                        default:
                                            return 'neutral'
                                    }
                                })()
                            }
                            sx={{
                                px: 0.2,
                                writingMode: 'vertical-rl',
                                textAlign: 'center',
                                fontSize: 'xs',
                                fontWeight: 'xl',
                                letterSpacing: '1px',
                                textTransform: 'uppercase',
                                borderLeft: '1px solid',
                                borderColor: 'divider',
                            }}
                        >
                            {this.props.opportunity.status_human}
                        </CardOverflow> :
                        null
                }

                <CardContent>
                    <Grid container spacing={2}>
                        <Grid xs={12} md={6} spacing={2} sx={{mb: 1}}>
                            <Stack

                            >
                                <Grid container spacing={2}>
                                    <Grid xs={12} md={4}>
                                        <Typography level={'body-sm'} sx={{mb: 1}}>Название:</Typography>
                                        <Link
                                            href={`/opportunity/detail/${this.props.opportunity.id}`}
                                            target={'_blank'}
                                        >
                                            {this.props.opportunity.short_name}
                                        </Link>
                                    </Grid>
                                    <Grid xs={12} md={4}>
                                        <Typography level={'body-sm'} sx={{mb: 1}}>Компания:</Typography>
                                        <Link
                                            href={`/account/detail/${this.props.opportunity.account.id}`}
                                            target={'_blank'}
                                        >
                                            {this.props.opportunity.account.nameshort}
                                        </Link>
                                    </Grid>
                                    <Grid xs={12} md={4}>
                                        <Typography level={'body-sm'} sx={{mb: 1}}>Дедлайн:</Typography>
                                        {dayjs(this.props.opportunity.project_date).format('DD.MM.YYYY')}
                                    </Grid>
                                    <Grid xs={12} md={4}>
                                        <Typography level={'body-sm'} sx={{mb: 1}}>Руководители:</Typography>
                                        {this.props.opportunity.accountables.map(
                                            row => {
                                                return (
                                                    <Chip
                                                        color={'warning'}
                                                        sx={{mr: 1, mb: 1}}
                                                        key={'accountable-chip-' + row.id}
                                                    >
                                                        {row.subscriber.user.first_name} {row.subscriber.user.last_name}
                                                    </Chip>
                                                )
                                            })}
                                    </Grid>
                                    <Grid xs={12} md={4}>
                                        <Typography level={'body-sm'} sx={{mb: 1}}>Мои роли:</Typography>
                                        {this.props.my_roles.map(
                                            row => {
                                                return (
                                                    <Chip
                                                        color={row.color}
                                                        sx={{mr: 1, mb: 1}}
                                                        key={'my-role-chip-' + row.id}
                                                    >
                                                        {row.role_human.slice(0, 3)}
                                                    </Chip>
                                                )
                                            })
                                        }
                                    </Grid>
                                    <Grid xs={12} md={4} sx={{mb: 2}}>
                                        <OpportunityPaymentCert
                                            opportunityID={this.props.opportunityID}
                                        />
                                    </Grid>
                                </Grid>
                                {
                                    this.context.userObject.is_superuser ?
                                        <CommonInfoTab
                                            callBack={this.props.retrieveOpportunity}
                                            flat={true}
                                            groups={
                                                [
                                                    {
                                                        // title: 'Прогнозные параметры',
                                                        flat: true,
                                                        // icon: <InfoIcon/>,
                                                        fields: [
                                                            {
                                                                title: 'Выручка',
                                                                value: this.props.opportunity.forecast_revenue,
                                                                xs: 12,
                                                                sm: 6,
                                                                md: 2,
                                                                lg: 2,
                                                                edit: {
                                                                    permission: this.context.userObject.is_superuser,
                                                                    fields: ['forecast_revenue',],
                                                                    baseUrl: 'opportunity',
                                                                    obj: this.props.opportunity,
                                                                }
                                                            },
                                                            {
                                                                title: 'Пред. %',
                                                                value: this.props.opportunity.forecast_prepay_rate,
                                                                xs: 12,
                                                                sm: 6,
                                                                md: 3,
                                                                lg: 2,
                                                                edit: {
                                                                    permission: this.context.userObject.is_superuser,
                                                                    fields: ['forecast_prepay_rate',],
                                                                    baseUrl: 'opportunity',
                                                                    obj: this.props.opportunity
                                                                }
                                                            },
                                                            {
                                                                title: 'Загрузка',
                                                                value: this.props.opportunity.forecast_workdays,
                                                                xs: 12,
                                                                sm: 6,
                                                                md: 3,
                                                                lg: 2,
                                                                edit: {
                                                                    permission: this.context.userObject.is_superuser,
                                                                    fields: ['forecast_workdays',],
                                                                    baseUrl: 'opportunity',
                                                                    obj: this.props.opportunity
                                                                }
                                                            },
                                                            {
                                                                title: 'Исп.',
                                                                value: this.props.opportunity.forecast_workers,
                                                                xs: 12,
                                                                sm: 6,
                                                                md: 3,
                                                                lg: 2,
                                                                edit: {
                                                                    permission: this.context.userObject.is_superuser,
                                                                    fields: ['forecast_workers',],
                                                                    baseUrl: 'opportunity',
                                                                    obj: this.props.opportunity
                                                                }
                                                            },
                                                            {
                                                                title: 'Дата начала',
                                                                value: this.props.opportunity.forecast_start_date ? dayjs(this.props.opportunity.forecast_start_date).format('DD MMM YYYY') : null,
                                                                xs: 12,
                                                                sm: 6,
                                                                md: 2,
                                                                lg: 2,
                                                                edit: {
                                                                    permission: this.context.userObject.is_superuser,
                                                                    fields: ['forecast_start_date',],
                                                                    baseUrl: 'opportunity',
                                                                    obj: this.props.opportunity
                                                                }
                                                            },
                                                            {
                                                                title: 'Хвост',
                                                                value: this.props.opportunity.forecast_tail,
                                                                xs: 12,
                                                                sm: 4,
                                                                md: 2,
                                                                lg: 2,
                                                                edit: {
                                                                    permission: this.context.userObject.is_superuser,
                                                                    fields: ['forecast_tail',],
                                                                    baseUrl: 'opportunity',
                                                                    obj: this.props.opportunity,
                                                                }
                                                            },
                                                        ]
                                                    }
                                                ]
                                            }
                                        /> :
                                        null
                                }
                                <Grid container spacing={2}>
                                    <Grid xs={12} md={12}>
                                        <Typography level={'h5'} sx={{mt: 1, mb: 1}}>Бизнес-процессы</Typography>
                                        <DeliveryTable
                                            deliveries={this.props.delivery_states}
                                            showOperator={true}
                                            showAccount={false}
                                            showOpportunity={false}
                                        />
                                    </Grid>
                                </Grid>

                            </Stack>
                        </Grid>
                        <Grid xs={12} md={6}>
                            <h5>Комментарии</h5>
                            <Stack
                                spacing={1}
                            >
                                {this.state.comments?.length === 0 ? <div className="alert alert-danger">
                                    <i className="icon fas fa-ban"></i> Нет ни одного комментария</div> : null}
                                {this.state.comments?.map(
                                    each => {
                                        return (
                                            <CommentItem
                                                comment={each}
                                                key={'comment-item-' + each.id}
                                                inlineReply={true}
                                                withCut
                                                addCommentCallBack={this.addComment.bind(this)}
                                            />
                                        )
                                    })}
                            </Stack>
                        </Grid>
                    </Grid>
                </CardContent>
                {
                    this.props.showRange ?
                        <CardOverflow
                            variant='soft'
                            color={this.props.color}
                            sx={{
                                px: 0.2,
                                writingMode: 'vertical-rl',
                                textAlign: 'center',
                                fontSize: 'xs',
                                fontWeight: 'xl',
                                letterSpacing: '1px',
                                textTransform: 'uppercase',
                                borderLeft: '1px solid',
                                borderColor: 'divider',
                            }}
                        >

                        </CardOverflow> :
                        null
                }

            </Card>
        )
    }
}

export default withNavigate(OpportunityFullCard)
